import _ from 'lodash'
import type {CssValue} from '../../constants'
import type {DecoratedStyleProperty} from '../../../../../decorations/styleProperties/constants'
import {hasValidKeys} from '../utils/object'
import {deserializeColor, serializeColor} from '../utils/color'

const VALID_KEYS = new Set(['value', 'additionalData'])
const VALID_ADDITIONAL_DATA_KEYS = new Set(['alpha'])

const serialize = (val: any): CssValue | undefined => {
    if (!_.isPlainObject(val) || _.isEmpty(val) || !hasValidKeys(val, VALID_KEYS)) {
        return undefined
    }

    const {value, additionalData} = val

    if (additionalData && !hasValidKeys(additionalData, VALID_ADDITIONAL_DATA_KEYS)) {
        return undefined
    }

    return serializeColor({value, alpha: additionalData?.alpha})
}

const deserialize = (rule: CssValue): DecoratedStyleProperty | undefined => {
    const color = deserializeColor(rule)
    if (!color) {
        return undefined
    }

    const {value, alpha} = color

    const styleProperty: DecoratedStyleProperty = {}

    if (value) {
        styleProperty.value = value
    }

    if (alpha) {
        styleProperty.additionalData = {alpha}
    }

    return styleProperty
}

export default {
    serialize,
    deserialize
}
